import React from 'react';

import { useSystem } from 'store/hooks';
import { Dashboard as DashboardNew } from './Dashboard';
import { Dashboard as DashboardOld } from './DashboardOld';

// Main export that renders the appropriate dashboard based on AI dashboard access.
export function Dashboard() {
	const { data } = useSystem();
	const hasAiTokens = data?.user.has_ai_tokens ?? false;
	const aiDashboardEnabled = data?.user.ai_dashboard_enabled ?? false;
	const aiAccessEnabled = data?.user.ai_access_enabled ?? false;

	if (hasAiTokens || (aiDashboardEnabled && aiAccessEnabled)) {
		return React.createElement(DashboardNew, null);
	}

	return React.createElement(DashboardOld, null);
}

export default Dashboard;
